/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/180-target': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 7h-1.577A6.516 6.516 0 009 1.577V0H7v1.577A6.516 6.516 0 001.577 7H0v2h1.577A6.516 6.516 0 007 14.423V16h2v-1.577A6.516 6.516 0 0014.423 9H16V7zm-3.612 0h-1.559A3.008 3.008 0 009 5.171V3.612A4.516 4.516 0 0112.388 7zM8 9a1 1 0 110-2 1 1 0 010 2zM7 3.612v1.559A3.008 3.008 0 005.171 7H3.612A4.516 4.516 0 017 3.612zM3.612 9h1.559A3.008 3.008 0 007 10.829v1.559A4.516 4.516 0 013.612 9zM9 12.388v-1.559A3.008 3.008 0 0010.829 9h1.559A4.516 4.516 0 019 12.388z"/>'
  }
})
